import {
  OrientationAxis,
  ViewportType,
} from "@cornerstonejs/core/enums";

export const MPRViewportsId = [
  "mprViewportAxial",
  "mprViewportSagittal",
  "mprViewportCoronal",
];

export const VOLUME_3D_VIEWPORT_ID = "mprViewport3D";

// activeMPRViewportIndex value that marks the 3D volume-render pane (the axial/
// sagittal/coronal panes use 0/1/2, matching MPRViewportsId's order).
export const VOLUME_3D_VIEWPORT_INDEX = 3;

export const getMPRViewportInputs = (
  axialElement,
  sagittalElement,
  coronalElement
) => {
  return [
    {
      viewportId: MPRViewportsId[0],
      type: ViewportType.ORTHOGRAPHIC,
      element: axialElement,
      defaultOptions: {
        orientation: OrientationAxis.AXIAL,
      },
    },
    {
      viewportId: MPRViewportsId[1],
      type: ViewportType.ORTHOGRAPHIC,
      element: sagittalElement,
      defaultOptions: {
        orientation: OrientationAxis.SAGITTAL,
      },
    },
    {
      viewportId: MPRViewportsId[2],
      type: ViewportType.ORTHOGRAPHIC,
      element: coronalElement,
      defaultOptions: {
        orientation: OrientationAxis.CORONAL,
      },
    },
  ];
};

export const get3DViewportInput = (element3D) => {
  return {
    viewportId: VOLUME_3D_VIEWPORT_ID,
    type: ViewportType.VOLUME_3D,
    element: element3D,
    defaultOptions: {
      orientation: OrientationAxis.CORONAL,
    },
  };
};
